var _defs, _sodipodiNamedview;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg922",
    xmlSpace: "preserve",
    width: 1363.0267,
    height: 480.82666,
    viewBox: "0 0 1363.0267 480.82666",
    sodipodiDocname: "logo watw.svg",
    inkscapeVersion: "1.1 (c68e22c387, 2021-05-23)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs926"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview924",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    inkscapeZoom: 0.12463072,
    inkscapeCx: 3325.8253,
    inkscapeCy: 1697.0134,
    "inkscapeWindow-width": 2400,
    "inkscapeWindow-height": 1271,
    "inkscapeWindow-x": 2391,
    "inkscapeWindow-y": -9,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g928",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,480.82667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g930",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4327.85,3095.68 h 389.51 l 104.3,-726.85 156.45,726.85 h 394.38 l 156.45,-726.85 104.31,726.85 h 389.49 l -264,-1153.82 h -449.8 l -133.63,655.13 -133.64,-655.13 h -449.8 l -264.02,1153.82",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6153.21,3147.84 h 361.8 v -426.99 c 52.14,79.86 143.41,146.68 281.94,146.68 211.85,0 335.72,-154.83 335.72,-392.77 v -532.9 H 6772.5 v 487.27 c 0,88.02 -50.52,141.79 -128.75,141.79 -79.86,0 -128.74,-53.77 -128.74,-141.79 v -487.27 h -361.8 v 1205.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7928,2861 h 399.28 L 7738.95,1501.84 h -396.01 l 231.43,485.65 -382.98,873.51 h 402.52 L 7766.67,2394.91 7928,2861",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4802.1,1251.96 c -162.97,0 -301.5,-118.96 -301.5,-329.19 0,-210.231 138.53,-334.09 301.5,-334.09 162.97,0 303.12,122.23 303.12,332.461 0,206.969 -140.15,330.819 -303.12,330.819 z m -29.34,128.75 c 166.23,0 280.31,-84.74 332.46,-177.64 v 162.98 h 149.93 V 472.98 h -149.93 v 166.231 c -53.78,-96.172 -169.48,-180.902 -334.09,-180.902 -237.94,0 -422.09,187.41 -422.09,464.461 0,278.67 184.15,457.94 423.72,457.94",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5538.79,1243.82 h -115.72 v 122.23 h 115.72 v 224.89 h 148.3 v -224.89 h 233.05 V 1243.82 H 5687.09 V 717.43 c 0,-88 32.59,-118.969 123.85,-118.969 h 109.2 V 472.98 h -133.63 c -158.1,0 -247.72,65.18 -247.72,244.45 v 526.39",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6428.66,1366.05 h 151.55 l 205.35,-749.671 221.63,749.671 h 151.57 l 216.75,-751.3 202.08,751.3 h 146.67 L 7445.58,472.98 h -153.19 l -215.12,708.9 -215.12,-708.9 h -153.18 l -280.31,893.07",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8260.5,588.68 c 154.82,0 306.39,105.929 306.39,332.461 0,224.889 -148.32,330.819 -301.5,330.819 -156.46,0 -298.25,-105.93 -298.25,-330.819 0,-226.532 138.53,-332.461 293.36,-332.461 z m 0,-130.371 c -252.59,0 -444.91,179.273 -444.91,462.832 0,281.929 198.83,459.569 451.43,459.569 254.23,0 451.42,-177.64 451.42,-459.569 0,-283.559 -203.71,-462.832 -457.94,-462.832",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9062.37,472.98 h -148.29 v 893.07 h 148.29 v -145.04 c 50.52,99.4 146.67,161.33 288.46,161.33 v -153.18 h -39.12 c -141.78,0 -249.34,-63.57 -249.34,-270.539 V 472.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9521.96,1678.95 h 148.3 V 970.031 l 343.84,396.019 h 207 L 9800.64,921.141 10222.7,472.98 h -202.1 L 9670.26,867.352 V 472.98 h -148.3 v 1205.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2843.27,458.891 H 762.887 c -167.61,0 -303.985,136.379 -303.985,303.988 V 2368.5 H 3147.25 V 762.879 c 0,-167.609 -136.38,-303.988 -303.98,-303.988 z m 0,3147.259 H 762.887 C 342.219,3606.15 0,3263.93 0,2843.27 V 762.879 C 0,342.211 342.219,0 762.887,0 H 2843.27 c 420.67,0 762.88,342.211 762.88,762.879 V 2843.27 c 0,420.66 -342.21,762.88 -762.88,762.88",
    style: {
      fill: "#f9a934",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path950"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/appLogo.40b1417b0877d8082a5ba3a83737e845.svg";
export { ForwardRef as ReactComponent };